export default "__VITE_ASSET__6ca446e0__"